import { render, staticRenderFns } from "./UtilitiesHistory.vue?vue&type=template&id=7bfdfd24&"
import script from "./UtilitiesHistory.vue?vue&type=script&lang=js&"
export * from "./UtilitiesHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports